/* London Labs · System 1D · Sky Utility */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (v) { return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var money = function (n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };

  /* Reveal: every content section on every page fades up once. */
  var NO_REVEAL = '#hero, .stage, [data-gx-act], .gx-hero, .gx__stage, [data-gx-line], [data-gx-bar], .gx-platebar, .gx-section, [data-gx-texture]';
  $$('main .shopify-section > :first-child').forEach(function (sec) {
    if (sec.matches(NO_REVEAL) || sec.querySelector(NO_REVEAL)) return;
    var box = sec.querySelector(':scope > .wrap') || sec;
    var kids = [].filter.call(box.children, function (k) {
      return !k.matches('[data-reveal], script, style, template') && !k.querySelector('[data-reveal]');
    });
    if (!sec.querySelector('[data-reveal]') && kids.length < 2) { sec.setAttribute('data-reveal', ''); return; }
    kids.forEach(function (k, i) {
      k.setAttribute('data-reveal', '');
      k.style.setProperty('--d', (i * 80) + 'ms');
    });
  });

  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-revealed');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $$('[data-reveal], [data-section], .section__head').forEach(function (el) { io.observe(el); });
  } else {
    $$('[data-reveal], [data-section], .section__head').forEach(function (el) { el.classList.add('is-revealed'); });
  }
  var hero = $('#hero');
  if (hero) hero.classList.add('is-revealed');

  /* Toasts — 180ms in, 3s hold */
  var toastHost = $('[data-toasts]');
  function toast(msg, kind) {
    if (!toastHost) return;
    var t = document.createElement('div');
    t.className = 'toast' + (kind ? ' toast--' + kind : '');
    t.innerHTML = '<svg width="18" height="18" style="flex:none"><use href="#ic-' + (kind === 'warn' ? 'shield' : 'check') + '"></use></svg><span></span>';
    t.lastChild.textContent = msg;
    toastHost.appendChild(t);
    setTimeout(function () {
      t.classList.add('is-out');
      setTimeout(function () { t.remove(); }, 220);
    }, 3000);
  }

  /* Steppers */
  function bump(input) {
    input.classList.remove('is-bumped');
    void input.offsetWidth;
    input.classList.add('is-bumped');
  }

  function initStepper(st) {
    if (st.dataset.bound) return;
    st.dataset.bound = '1';
    var input = $('.stepper__value', st);
    if (!input) return;
    var min = parseInt(st.dataset.min || '0', 10);
    var max = parseInt(st.dataset.max || '9999', 10);

    function set(v) {
      v = Math.max(min, Math.min(max, isNaN(v) ? min : v));
      if (String(v) !== input.value) bump(input);
      input.value = v;
      $$('[data-step]', st).forEach(function (b) {
        b.disabled = (b.dataset.step === '-1' && v <= min) || (b.dataset.step === '1' && v >= max);
      });
      st.dispatchEvent(new CustomEvent('qty', { bubbles: true, detail: v }));
    }

    $$('[data-step]', st).forEach(function (b) {
      b.addEventListener('click', function () { set(parseInt(input.value, 10) + parseInt(b.dataset.step, 10)); });
    });
    input.addEventListener('change', function () { set(parseInt(input.value, 10)); });
    set(parseInt(input.value, 10));
  }

  // Every stepper on the page and every one rendered later goes through this.
  function bindSteppers(root) { $$('[data-stepper]', root || document).forEach(initStepper); }
  bindSteppers();

  /* Cart — one store, three views (drawer, page, counters) */

  var cart = [];

  function pullCart(then) {
    if (!window.fetch) { return; }
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart = (c.items || []).map(function (l) {
          return { key: l.key, name: l.product_title, variant: l.variant_title,
                   price: l.final_price / 100, qty: l.quantity,
                   image: l.image, url: l.url };
        });
        renderCart();
        if (then) { then(c); }
      })
      .catch(function () {});
  }

  var busy = {};
  function cartChange(key, qty) {
    if (!window.fetch || busy[key]) { return; }   /* one change per line at a time */
    busy[key] = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).catch(function () {}).then(function () { busy[key] = false; pullCart(); });
  }
  var drawer = $('[data-drawer]');
  var scrim = $('[data-scrim]');
  var lastFocus = null;

  function cartCount() { return cart.reduce(function (n, l) { return n + l.qty; }, 0); }
  function cartSubtotal() { return cart.reduce(function (n, l) { return n + l.qty * l.price; }, 0); }

  function renderCart() {
    var count = cartCount();
    var sub = cartSubtotal();

    $$('[data-cart-count]').forEach(function (n) { n.textContent = count; });
    var dc = $('[data-drawer-count]'); if (dc) dc.textContent = count;
    var dt = $('[data-drawer-total]'); if (dt) dt.textContent = money(sub);

    // Drawer
    var dl = $('[data-drawer-lines]');
    if (dl) {
      if (!cart.length) {
        dl.innerHTML = '<div class="empty"><div class="empty__art"><svg width="28" height="28"><use href="#ic-cart"></use></svg></div>' +
          '<div class="empty__title">Nothing in the cart yet</div>' +
          '<p class="empty__body">Add a case from any product card and it turns up here.</p></div>';
      } else {
        dl.innerHTML = cart.map(function (l, i) {
          return '<div class="drawer-line"><span style="font-size:14px;font-weight:700;color:var(--drawer-ink, var(--navy-700))">' + esc(l.name) + '</span>' +
            '<span class="mono-plain" style="font-size:13px;color:var(--drawer-ink, var(--navy-700))">' + money(l.qty * l.price) + '</span>' +
            '<span class="mono-plain" style="font-size:11px;color:var(--drawer-muted, var(--muted))">' + (l.variant ? esc(l.variant) + ' · ' : '') + l.qty + ' × ' + money(l.price) + '</span>' +
            '<button class="btn btn--link" style="height:auto;font-size:12px;justify-self:end;color:var(--red-500)" data-drop="' + i + '">Remove</button></div>';
        }).join('');
      }
    }

  }

  document.addEventListener('click', function (e) {
    var drop = e.target.closest('[data-drop]');
    if (drop) {
      var line = cart[+drop.dataset.drop];
      if (line) { cartChange(line.key, 0); toast(line.name + ' removed', 'warn'); }
      return;
    }
    var step = e.target.closest('[data-line-step]');
    if (step) {
      var i = +step.closest('[data-line-qty]').dataset.lineQty;
      var ln = cart[i];
      if (ln) { cartChange(ln.key, Math.max(0, ln.qty + parseInt(step.dataset.lineStep, 10))); }
    }
  });

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.hidden = false; scrim.hidden = false;
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      scrim.classList.add('is-open');
      var x = $('[data-close-cart]'); if (x) x.focus();
    });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    scrim.classList.remove('is-open');
    setTimeout(function () {
      drawer.hidden = true; scrim.hidden = true;
      if (lastFocus) lastFocus.focus();
    }, 250);
  }

  pullCart();
  document.addEventListener('cart:changed', function () { pullCart(); });

  $$('[data-open-cart]').forEach(function (b) { b.addEventListener('click', openCart); });
  $$('[data-close-cart]').forEach(function (b) { b.addEventListener('click', closeCart); });
  // One scrim, three dialogs — dismiss whichever is open.
  if (scrim) scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
    if (e.key === 'Tab' && drawer && drawer.classList.contains('is-open')) {
      var f = $$('button, [href], input, select, textarea', drawer).filter(function (n) { return !n.disabled; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* Form validation — errors name the problem and the recovery */
  var rules = {
    email: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) ? null : 'That address is missing an @ or a domain — try ops@yourcompany.com.'; },
    zip: function (v) { return /^\d{5}(-\d{4})?$/.test(v) ? null : 'We need five digits to work out delivery — 10018, for example.'; },
    qty: function (v) { return parseInt(v, 10) >= 1 ? null : 'Nothing to ship yet — set this to 1 or more.'; }
  };
  var okHint = { email: '', zip: '', qty: '' };

  $$('[data-validate]').forEach(function (field) {
    var kind = field.dataset.validate;
    var input = $('.input', field);
    var hint = $('.field__hint', field);
    function check() {
      var err = rules[kind](input.value.trim());
      if (err) { field.dataset.state = 'error'; hint.textContent = err; }
      else { field.dataset.state = 'valid'; hint.textContent = okHint[kind]; }
    }
    input.addEventListener('blur', check);
    input.addEventListener('input', function () {
      if (field.dataset.state === 'error') check();
    });
  });

  /* Required fields on novalidate forms: checked on submit, first problem focused. */
  function requiredMsg(el) {
    if (el.type === 'checkbox') return 'Tick this to confirm before you send.';
    if (el.tagName === 'SELECT') return 'Choose one to continue.';
    return 'This one is needed — fill it in to continue.';
  }
  $$('form[novalidate]').forEach(function (form) {
    $$('[required]', form).forEach(function (el) {
      var field = el.closest('.field');
      if (!field) return;
      var hint = $('.field__hint', field);
      if (!hint) {
        hint = document.createElement('p');
        hint.className = 'field__hint';
        hint.id = el.id + '-hint';
        hint.hidden = true;
        el.setAttribute('aria-describedby', hint.id);
        field.appendChild(hint);
      }
      var original = hint.innerHTML;
      el._reqCheck = function () {
        var v = el.type === 'checkbox' ? el.checked : el.value.trim();
        if (!v) {
          field.dataset.state = 'error';
          hint.textContent = requiredMsg(el);
          hint.hidden = false;
          el.setAttribute('aria-invalid', 'true');
          return false;
        }
        if (!field.dataset.validate) {
          delete field.dataset.state;
          hint.innerHTML = original;
          hint.hidden = !original;
        }
        el.removeAttribute('aria-invalid');
        return true;
      };
      el.addEventListener(el.type === 'checkbox' || el.tagName === 'SELECT' ? 'change' : 'input', function () {
        if (field.dataset.state === 'error') el._reqCheck();
      });
    });
    form.addEventListener('submit', function (e) {
      var first = firstInvalid(form);
      if (!first) return;
      e.preventDefault();
      if (form._goToStep) form._goToStep(first);
      first.focus();
    });
  });
  function firstInvalid(scope) {
    var first = null;
    $$('[required]', scope).forEach(function (el) {
      var ok = el._reqCheck ? el._reqCheck() : true;
      if (ok && el.closest('[data-validate]')) {
        el.dispatchEvent(new Event('blur'));
        ok = el.closest('.field').dataset.state !== 'error';
      }
      if (!ok && !first) first = el;
    });
    return first;
  }

  /* A sticky form taller than the window would hide its buttons; pin it
     by its bottom edge instead so Next / Submit stay on screen. */
  var stickyForms = $$('.ctform');
  function fitSticky() {
    stickyForms.forEach(function (f) {
      f.style.top = '';
      if (getComputedStyle(f).position !== 'sticky') return;
      var top = parseFloat(getComputedStyle(f).top) || 0;
      var room = window.innerHeight - f.offsetHeight - 16;
      if (room < top) f.style.top = room + 'px';
    });
  }
  window.addEventListener('resize', fitSticky);
  fitSticky();

  /* Stepped forms: one fieldset at a time. Without JS every step shows. */
  $$('form').forEach(function (form) {
    var steps = $$('[data-step]', form);
    if (steps.length < 2) return;
    var prev = $('[data-step-prev]', form);
    var next = $('[data-step-next]', form);
    var submit = $('[type="submit"]', form);
    var progress = $('[data-step-progress]', form);
    var at = 0;
    function show(n, move) {
      at = n;
      steps.forEach(function (s, k) { s.hidden = k !== n; });
      prev.hidden = n === 0;
      next.hidden = n === steps.length - 1;
      submit.hidden = !next.hidden;
      progress.hidden = false;
      progress.textContent = 'Step ' + (n + 1) + ' of ' + steps.length;
      fitSticky();
      if (!move) return;
      if (form.getBoundingClientRect().top < 0) form.scrollIntoView({ block: 'start' });
      var f = $('input, select, textarea', steps[n]);
      if (f) f.focus({ preventScroll: true });
    }
    form._goToStep = function (el) {
      var n = steps.indexOf(el.closest('[data-step]'));
      if (n > -1 && n !== at) show(n, false);
    };
    next.addEventListener('click', function () {
      var bad = firstInvalid(steps[at]);
      if (bad) { bad.focus(); return; }
      show(at + 1, true);
    });
    prev.addEventListener('click', function () { show(at - 1, true); });
    /* Enter in a field moves forward instead of submitting a half-filled form. */
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT' && e.target.type !== 'checkbox' && at < steps.length - 1) {
        e.preventDefault();
        next.click();
      }
    });
    show(0, false);
  });

  /* In-page links to a section laid out with display: contents (the form
     rail) have no box to scroll to; land on its first child that does. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.hash.length < 2) return;
    var t = document.getElementById(a.hash.slice(1));
    while (t && getComputedStyle(t).display === 'contents') t = t.firstElementChild;
    if (!t || t.id === a.hash.slice(1)) return;
    e.preventDefault();
    t.scrollIntoView({ block: 'start' });
    history.pushState(null, '', a.hash);
  });

  /* After a successful post, bring the confirmation into view. */
  var done = $('[data-form-done]');
  if (done) { done.scrollIntoView({ block: 'center' }); done.focus({ preventScroll: true }); }

})();

/* Variant picker guidance, shared by the product page, quick view and the
   GRIPXX buy panels. `variants` items need .options[] and .available;
   `want` is the chosen value per option; `names` the option names. */
window.LLVariantHint = (function () {
  'use strict';
  function same(a, b, skip) {
    for (var i = 0; i < a.length; i++) { if (i !== skip && a[i] !== b[i]) { return false; } }
    return true;
  }
  function others(want, skip) {
    return want.filter(function (x, i) { return i !== skip && x; }).join(' / ');
  }
  /* The option that, changed alone, leads to something in stock. */
  function culprit(variants, want) {
    for (var p = want.length - 1; p >= 0; p--) {
      for (var k = 0; k < variants.length; k++) {
        var v = variants[k];
        if (v.available && v.options[p] !== want[p] && same(v.options, want, p)) { return p; }
      }
    }
    return -1;
  }
  function soldOut(variants, want, names) {
    var p = culprit(variants, want);
    if (p < 0) { return 'This option is sold out right now.'; }
    var rest = others(want, p);
    return want[p] + ' is sold out' + (rest ? ' in ' + rest : '') + '. Choose another ' + String(names[p] || 'option').toLowerCase() + '.';
  }
  function missing(want, pos) {
    return want[pos] + ' isn\'t sold in ' + (others(want, pos) || 'that combination') + '. Choose another option.';
  }
  /* Options the picker changed by itself to reach a real variant. */
  function switched(want, got, names, pin) {
    var changed = [];
    for (var i = 0; i < want.length; i++) {
      if (i !== pin && want[i] && got[i] !== want[i]) { changed.push(String(names[i] || 'option').toLowerCase() + ' changed to ' + got[i]); }
    }
    if (!changed.length) { return ''; }
    return want[pin] + ' isn\'t sold in ' + others(want, pin) + ', so ' + changed.join(' and ') + '.';
  }
  return { soldOut: soldOut, missing: missing, switched: switched };
}());
